import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function LogAdvisorNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="menu_book_icon"
      nodeData={{ ...data, label: msg({ id: 'field.advisors.log.label' }) }}
      color="primary"
      handleConf={handleConf}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '280px' }}>
        {data?.description && (
          <CompactNodeField
            label={msg({ id: 'field.description.label' })}
            value={data?.description || ''}
          />
        )}
        {data?.logPath && (
          <CompactNodeField
            label={msg({ id: 'field.advisors.log.path' })}
            value={data?.logPath || ''}
          />
        )}
      </Stack>
    </BaseNode>
  );
}

LogAdvisorNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string,
    logPath: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
